'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from './Icon';
import { Button } from './ui/button';
import { useTheme } from '../theme';
/**
 * ThemeToggle - переключатель темы. На Button пресета (единица 13).
 *
 * ЧТО ИЗМЕНИЛОСЬ. Прежде это был штатный механизм FlyonUI: `swap` для
 * поворота иконок и невидимый `input.theme-controller`, по состоянию
 * которого библиотека применяла тему. Механизм уходит вместе с FlyonUI, а
 * заодно уходит дефект, который он давал: ворота геометрии единицы 13
 * померили этот чекбокс и получили 24×0 px - органа управления на экране
 * фактически не было, доступен он был только с клавиатуры.
 *
 * Теперь это обычная кнопка: одна иконка по текущей теме, нажатие
 * переключает. Сохранение выбора между визитами и отсутствие вспышки при
 * загрузке остались прежними - они живут в `theme.ts` и `theme-boot.ts`.
 */
export function ThemeToggle({ className }) {
    const { theme, setTheme } = useTheme();
    const dark = theme === 'dark';
    return (_jsx(Button, { type: "button", variant: "ghost", size: "icon", className: className, title: dark ? 'Включить светлую тему' : 'Включить тёмную тему', "aria-label": dark ? 'Включить светлую тему' : 'Включить тёмную тему', "aria-pressed": dark, onClick: () => {
            setTheme(dark ? 'light' : 'dark');
        }, children: _jsx(Icon, { name: dark ? 'sun' : 'moon' }) }));
}
//# sourceMappingURL=ThemeToggle.js.map